
{
  "familyId": "TIJD-AFSTAND",
  "questions": [
    {
      "id": "TIJD-AFSTAND-001",
      "familyId": "TIJD-AFSTAND",
      "module": "Tijd",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "afstand_berekenen",
      "questionType": "multiple_choice",
      "question": "Een auto rijdt 80 km/u. Hoe ver komt hij in 3 uur?",
      "options": [
        "240 km",
        "83 km",
        "160 km",
        "320 km"
      ],
      "correctAnswer": 0,
      "conceptId": "afstand_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.76,
      "context": "Autorit",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.speed-formula-confused", "label": "Optellen ipv vermenigvuldigen", "optionIndex": 1 },
          { "id": "tijd.speed-formula-confused", "label": "Verkeerde tijd gelezen (2 ipv 3 uur)", "optionIndex": 2 },
          { "id": "tijd.speed-formula-confused", "label": "Verkeerde tijd gelezen (4 ipv 3 uur)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "speed": 80,
            "time": 3,
            "unknown": "distance",
            "label": "Autorit"
          }
        }
      ],
      "supportAids": [
        {
          "type": "speedDiagram",
          "showWhen": "wrong",
          "data": {
            "speed": 80,
            "distance": 240,
            "time": 3,
            "unknown": "distance",
            "label": "Afstand = snelheid × tijd"
          }
        }
      ],
      "feedback": {
        "explanationText": "Je wilt weten hoe ver de auto komt. Daarvoor gebruik je de formule: afstand = snelheid × tijd. De auto rijdt 80 kilometer per uur. Dat betekent dat hij elk uur 80 km aflegt. In 3 uur legt hij dus 3 keer zoveel af: 80 × 3 = 240 km. Controleer: als je 240 km deelt door 3 uur, krijg je 80 km/u — dat klopt!",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 80 km/u, tijd = 3 uur",
          "Gebruik de formule: afstand = snelheid × tijd",
          "Reken uit: 80 × 3 = 240 km",
          "Controleer: 240 ÷ 3 = 80 km/u ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 80 × 3 = 240 km.",
          "1": "Je hebt 80 + 3 = 83 berekend. Maar afstand = snelheid × tijd, niet snelheid + tijd. Km/u en uren kun je niet optellen — je moet vermenigvuldigen. Onthoud: afstand = snelheid × tijd.",
          "2": "Je hebt 80 × 2 = 160 berekend. Maar de auto rijdt 3 uur, niet 2 uur. Lees de tijd goed en vermenigvuldig: 80 × 3 = 240 km.",
          "3": "Je hebt 80 × 4 = 320 berekend. Maar de auto rijdt 3 uur, niet 4 uur. Lees de opgave goed: 80 × 3 = 240 km."
        }
      }
    },
    {
      "id": "TIJD-AFSTAND-002",
      "familyId": "TIJD-AFSTAND",
      "module": "Tijd",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "afstand_berekenen",
      "questionType": "multiple_choice",
      "question": "Een fietser rijdt 15 km/u. Hoe ver komt hij in 1,5 uur?",
      "options": [
        "22,5 km",
        "16,5 km",
        "15 km",
        "30 km"
      ],
      "correctAnswer": 0,
      "conceptId": "afstand_komma",
      "variantIndex": 2,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.73,
      "context": "Fietstocht",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.speed-formula-confused", "label": "Optellen ipv vermenigvuldigen", "optionIndex": 1 },
          { "id": "tijd.minutes-to-hours-error", "label": "Halve uur vergeten", "optionIndex": 2 },
          { "id": "tijd.minutes-to-hours-error", "label": "1,5 uur gelezen als 2 uur", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "speed": 15,
            "time": 1.5,
            "unknown": "distance",
            "label": "Fietstocht"
          }
        }
      ],
      "supportAids": [
        {
          "type": "speedDiagram",
          "showWhen": "wrong",
          "data": {
            "speed": 15,
            "distance": 22.5,
            "time": 1.5,
            "unknown": "distance",
            "label": "Afstand met kommagetal"
          }
        }
      ],
      "feedback": {
        "explanationText": "De fietser rijdt 15 km per uur en is 1,5 uur onderweg. Afstand = snelheid × tijd = 15 × 1,5. Een handige tip: splits 1,5 in 1 + 0,5. Dan: 15 × 1 = 15 km (het eerste uur) en 15 × 0,5 = 7,5 km (het halve uur). Samen: 15 + 7,5 = 22,5 km. Controleer: 22,5 ÷ 1,5 = 15 km/u ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 15 km/u, tijd = 1,5 uur",
          "Splits de berekening: 15 × 1 = 15 km",
          "15 × 0,5 = 7,5 km",
          "Tel op: 15 + 7,5 = 22,5 km",
          "Controleer: 22,5 ÷ 1,5 = 15 km/u ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 × 1,5 = 22,5 km.",
          "1": "Je hebt 15 + 1,5 = 16,5 berekend. Maar afstand = snelheid × tijd, niet +. Km/u en uren vermenigvuldig je. Onthoud: afstand = snelheid × tijd.",
          "2": "Je hebt alleen 15 × 1 = 15 berekend en het halve uur vergeten. 1,5 uur = 1 uur + 30 minuten. In dat halve uur legt de fietser nog 7,5 km af. Totaal: 22,5 km.",
          "3": "Je hebt 15 × 2 = 30 berekend. Maar de fietser rijdt 1,5 uur, niet 2 uur. Lees de tijd nauwkeurig: 1,5 × 15 = 22,5 km."
        }
      }
    },
    {
      "id": "TIJD-AFSTAND-003",
      "familyId": "TIJD-AFSTAND",
      "module": "Tijd",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "afstand_berekenen",
      "questionType": "multiple_choice",
      "question": "Een trein rijdt 120 km/u. Hoe ver komt hij in 45 minuten?",
      "options": [
        "90 km",
        "120 km",
        "165 km",
        "60 km"
      ],
      "correctAnswer": 0,
      "conceptId": "afstand_minuten",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "context": "Treinreis",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-to-hours-error", "label": "45 min als 1 uur gerekend", "optionIndex": 1 },
          { "id": "tijd.eenheden-optellen", "label": "Snelheid + minuten direct opgeteld", "optionIndex": 2 },
          { "id": "tijd.minutes-to-hours-error", "label": "45 min = 0,5 uur fout", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "speed": 120,
            "time": 0.75,
            "timeUnit": "uur (45 min)",
            "unknown": "distance",
            "label": "Treinreis"
          }
        }
      ],
      "supportAids": [
        {
          "type": "speedDiagram",
          "showWhen": "wrong",
          "data": {
            "speed": 120,
            "distance": 90,
            "time": 0.75,
            "timeUnit": "uur (45 min)",
            "unknown": "distance",
            "label": "Minuten naar uren"
          }
        }
      ],
      "feedback": {
        "explanationText": "De trein rijdt 120 km/u, maar is maar 45 minuten onderweg. Omdat de snelheid in km per uur is, moet je de minuten eerst omrekenen naar uren. 45 minuten ÷ 60 = 0,75 uur (dat is ¾ uur). Nu kun je rekenen: afstand = 120 × 0,75 = 90 km. Je kunt het ook zo bedenken: in 1 uur legt de trein 120 km af. In ¾ uur is dat ¾ × 120 = 90 km. Controleer: 90 ÷ 0,75 = 120 km/u ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 120 km/u, tijd = 45 minuten",
          "Reken minuten om naar uren: 45 ÷ 60 = 0,75 uur",
          "Gebruik de formule: afstand = snelheid × tijd",
          "Reken uit: 120 × 0,75 = 90 km",
          "Controleer: 90 ÷ 0,75 = 120 km/u ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 45 min = 0,75 uur, en 120 × 0,75 = 90 km.",
          "1": "Je dacht waarschijnlijk dat 45 minuten = 1 uur. Maar 45 min = ¾ uur = 0,75 uur. Reken altijd minuten om naar uren voordat je de formule gebruikt: 120 × 0,75 = 90 km.",
          "2": "Je hebt 120 + 45 = 165 berekend. Maar afstand = snelheid × tijd, niet snelheid + minuten. Bovendien moet je de minuten eerst omrekenen naar uren: 45 min = 0,75 uur.",
          "3": "Je dacht waarschijnlijk dat 45 min = 0,5 uur (een half uur). Maar 30 min = 0,5 uur, en 45 min = 0,75 uur. Reken: 45 ÷ 60 = 0,75. Dan: 120 × 0,75 = 90 km."
        }
      }
    },
    {
      "id": "TIJD-AFSTAND-004",
      "familyId": "TIJD-AFSTAND",
      "module": "Tijd",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "afstand_berekenen",
      "questionType": "multiple_choice",
      "question": "Een vliegtuig vliegt 900 km/u. De vlucht duurt 2 uur en 20 minuten. Hoe ver is de bestemming?",
      "options": [
        "2100 km",
        "1800 km",
        "2700 km",
        "920 km"
      ],
      "correctAnswer": 0,
      "conceptId": "afstand_samengesteld",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.69,
      "context": "Vliegtuigreis",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minutes-to-hours-error", "label": "20 minuten vergeten", "optionIndex": 1 },
          { "id": "tijd.minutes-to-hours-error", "label": "20 min als 1 heel uur gerekend", "optionIndex": 2 },
          { "id": "tijd.eenheden-optellen", "label": "Snelheid + minuten direct opgeteld", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "speed": 900,
            "time": 2.333,
            "timeUnit": "uur (2u 20m)",
            "unknown": "distance",
            "label": "Vliegtuigreis"
          }
        }
      ],
      "supportAids": [
        {
          "type": "speedDiagram",
          "showWhen": "wrong",
          "data": {
            "speed": 900,
            "distance": 2100,
            "time": 2.333,
            "timeUnit": "uur (2u 20m)",
            "unknown": "distance",
            "label": "Uren en minuten combineren"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het vliegtuig vliegt 900 km/u en is 2 uur en 20 minuten onderweg. Eerst reken je de tijd om: 20 minuten = 20 ÷ 60 = ⅓ uur. De totale tijd is dus 2⅓ uur. Nu kun je de afstand berekenen: 900 × 2⅓. Splits dit op: 900 × 2 = 1800 km en 900 × ⅓ = 300 km. Samen: 1800 + 300 = 2100 km. Controleer: 2100 ÷ 900 = 2,33... uur = 2 uur 20 min ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 900 km/u, tijd = 2 uur 20 min",
          "Reken minuten om: 20 min = ⅓ uur → totaal 2⅓ uur",
          "Splits de berekening: 900 × 2 = 1800 km",
          "900 × ⅓ = 300 km",
          "Tel op: 1800 + 300 = 2100 km"
        ],
        "distractorExplanations": {
          "0": "Goed! 900 × 2⅓ = 2100 km.",
          "1": "Je hebt alleen 900 × 2 = 1800 berekend en de 20 minuten vergeten. 20 min = ⅓ uur, dus de trein legt nog 900 × ⅓ = 300 km extra af. Totaal: 1800 + 300 = 2100 km.",
          "2": "Je hebt 900 × 3 = 2700 berekend. Maar 2 uur 20 min is niet 3 uur — het is 2⅓ uur. 20 minuten = ⅓ uur, niet 1 heel uur.",
          "3": "Je hebt 900 + 20 = 920 berekend. Maar afstand = snelheid × tijd, niet snelheid + minuten. Reken de tijd om naar uren en vermenigvuldig: 900 × 2⅓ = 2100 km."
        }
      }
    },
    {
      "id": "TIJD-AFSTAND-005",
      "familyId": "TIJD-AFSTAND",
      "module": "Tijd",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "afstand_berekenen",
      "questionType": "fill_in",
      "question": "Een bus rijdt 60 km/u. Hoe ver komt hij in 2,5 uur? Typ je antwoord in km.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": [
          "150",
          "150 km",
          "150km",
          "150 kilometer"
        ],
        "caseSensitive": false,
        "placeholder": "? km"
      },
      "conceptId": "afstand_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.74,
      "context": "Busrit",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "speed": 60,
            "time": 2.5,
            "unknown": "distance",
            "label": "Busrit"
          }
        }
      ],
      "supportAids": [
        {
          "type": "speedDiagram",
          "showWhen": "wrong",
          "data": {
            "speed": 60,
            "distance": 150,
            "time": 2.5,
            "unknown": "distance",
            "label": "Afstand berekenen"
          }
        }
      ],
      "feedback": {
        "explanationText": "De bus rijdt 60 km per uur en is 2,5 uur onderweg. Afstand = snelheid × tijd = 60 × 2,5. Een handige tip: splits 2,5 in 2 + 0,5. Dan: 60 × 2 = 120 km (de eerste 2 uur) en 60 × 0,5 = 30 km (het halve uur). Samen: 120 + 30 = 150 km. Controleer: 150 ÷ 2,5 = 60 km/u ✓.",
        "solutionSteps": [
          "Schrijf de gegevens op: snelheid = 60 km/u, tijd = 2,5 uur",
          "Splits de berekening: 60 × 2 = 120 km",
          "60 × 0,5 = 30 km",
          "Tel op: 120 + 30 = 150 km",
          "Controleer: 150 ÷ 2,5 = 60 km/u ✓"
        ]
      }
    }
  ]
}
